export default class Constants {
  static PreferencesSegment = 'preferences';
  static BasePagePath = `/${Constants.PreferencesSegment}`;
  static PreferencesCommunicationChangeSegment = 'communication/change';
  static PreferencesCommunicationChangeConfirmationSegment = `${Constants.PreferencesCommunicationChangeSegment}/confirmation`;
  static PreferencesCommunicationChangePath = `${Constants.BasePagePath}/${Constants.PreferencesCommunicationChangeSegment}`;
  static PreferencesCommunicationChangeConfirmationPath = `${Constants.PreferencesCommunicationChangePath}/confirmation`;
}
